import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import EstimateForm from '../../components/feature/EstimateForm';
import FinalCTA from '../home/components/FinalCTA';
import { locations } from '../../mocks/locations';

export default function LocationsPage() {
  const [formOpen, setFormOpen] = useState(false);

  return (
    <div className="min-h-screen font-sans">
      <Header onEstimateClick={() => setFormOpen(true)} />
      <main>
        <section className="relative pt-40 pb-24 px-6 overflow-hidden">
          {/* Background Image */}
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/a973fa5f5444432995d58a3566ce30dc.jpg"
              alt="Hardwood flooring services across Maryland"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-black/70" />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50" />
          </div>
          <div className="relative max-w-4xl mx-auto text-center">
            <nav className="flex justify-center gap-2 text-sm text-white/70 font-sans mb-8">
              <Link to="/" className="hover:text-gold transition-colors">Home</Link>
              <span>/</span>
              <span className="text-gold">Locations</span>
            </nav>
            <h1
              className="font-serif text-5xl md:text-6xl text-white font-bold leading-tight mb-5"
              style={{ textShadow: '0 2px 16px rgba(0,0,0,0.85), 0 1px 4px rgba(0,0,0,0.9)' }}
            >
              Hardwood Flooring Services<span className="block text-gold text-4xl mt-2">Across Maryland</span>
            </h1>
            <p
              className="font-sans text-lg text-white leading-relaxed max-w-2xl mx-auto mb-10"
              style={{ textShadow: '0 1px 8px rgba(0,0,0,0.8)' }}
            >
              Premier Hardwood Floors serves homeowners throughout Maryland with expert installation, refinishing, repair, and replacement.
            </p>
            <button onClick={() => setFormOpen(true)} className="px-10 py-4 bg-gold text-walnut font-semibold rounded-lg hover:bg-gold-dark transition-colors font-sans text-base whitespace-nowrap">
              Get a Free Estimate
            </button>
          </div>
        </section>

        <section className="bg-white py-24 px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-14">
              <span className="font-sans text-xs uppercase tracking-widest text-oak font-semibold">Service Areas</span>
              <h2 className="font-serif text-4xl text-walnut font-bold mt-3">Cities We Serve</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {locations.map((loc) => (
                <Link key={loc.slug} to={`/locations/${loc.slug}`} className="group bg-sand rounded-2xl overflow-hidden border border-sand-dark hover:border-oak/40 transition-all cursor-pointer">
                  <div className="relative h-48 overflow-hidden">
                    <img src={loc.image} alt={`Hardwood flooring in ${loc.name}, MD`} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-walnut/70 to-transparent" />
                    <div className="absolute bottom-4 left-5">
                      <span className="font-serif text-2xl text-white font-bold">{loc.name}</span>
                      <span className="block font-sans text-xs text-gold">{loc.state}</span>
                    </div>
                  </div>
                  <div className="p-6">
                    <p className="font-sans text-sm text-charcoal/70 leading-relaxed mb-5">{loc.description}</p>
                    <div className="flex flex-wrap gap-2 mb-5">
                      {loc.highlights.slice(0, 3).map((h) => (
                        <span key={h} className="px-3 py-1 bg-white border border-sand-dark text-xs text-charcoal/60 rounded-full font-sans">{h}</span>
                      ))}
                    </div>
                    <div className="flex items-center gap-1.5 text-oak font-sans text-sm font-medium group-hover:gap-3 transition-all">
                      View {loc.name} Services <i className="ri-arrow-right-line" />
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="bg-sand py-20 px-6">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="font-serif text-3xl text-walnut font-bold mb-4">Don&apos;t See Your City?</h2>
            <p className="font-sans text-base text-charcoal/70 mb-8">We serve many communities throughout Maryland. Contact us to confirm service availability in your area.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button onClick={() => setFormOpen(true)} className="px-8 py-3.5 bg-walnut text-white rounded-lg font-sans text-sm font-semibold hover:bg-walnut-dark transition-colors whitespace-nowrap">Request Estimate for My Area</button>
              <a href="tel:+14105550192" className="px-8 py-3.5 border-2 border-walnut text-walnut rounded-lg font-sans text-sm font-medium hover:bg-white transition-colors whitespace-nowrap flex items-center justify-center gap-2"><i className="ri-phone-line" /> (410) 555-0192</a>
            </div>
          </div>
        </section>

        <FinalCTA onEstimateClick={() => setFormOpen(true)} heading="Serving Maryland Homeowners" subtext="Expert hardwood flooring wherever you are in Maryland." />
      </main>
      <Footer onEstimateClick={() => setFormOpen(true)} />
      <EstimateForm isOpen={formOpen} onClose={() => setFormOpen(false)} />
    </div>
  );
}
